import React, { useState, useEffect } from 'react';
import './CartPage.css';

import logoImage from './../../image/logo.svg';
import delIcon from './../../image/del-icon.svg';
import closeIcon from './../../image/close.svg';
import axios from 'axios';

const CartPage = ({
    setCurrentPage,
    setTotalSum,
    totalSum,
    setIsShowSuccess,
    setSuccessStatus,
    setIsShowError,
    setErrorStatus,
    loadingHistory,
    loadingCurrentOrder,
    setProductCount,
    cartItems,
    setCartItems,
}) => {
    const [isShowDeleteModal, setIsShowDeleteModal] = useState(false);

    // загрузка товаров из localstorage
    useEffect(() => {
        const loadCartItems = () => {
            const items = [];
            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key.startsWith('product_')) {
                    const item = JSON.parse(localStorage.getItem(key));
                    items.push(item);
                }
            }
            setCartItems(items);
        };

        loadCartItems();
    }, []);

    // удаление товара из корзины
    const handleDeleteItem = (id, price, quantity) => {
        localStorage.removeItem(`product_${id}`);
        setCartItems((prevItems) => prevItems.filter((item) => item.id !== id));

        const newTotalSum = totalSum - price * quantity;
        setTotalSum(newTotalSum);
        localStorage.setItem('totalSum', newTotalSum);
    };

    // очистка всей корзины
    const handleClearCart = () => {
        const keys = Object.keys(localStorage);

        keys.forEach((key) => {
            if (key.startsWith('product_')) {
                localStorage.removeItem(key);
            }
        });

        setCartItems([]);
        setTotalSum(0);
        setProductCount({});
        localStorage.setItem('totalSum', 0);
        setIsShowDeleteModal(false);
    };

    // клик на "очистить корзину"
    const handleDelBtnClick = () => {
        setIsShowDeleteModal(true);
    };

    // закрыть "очистить корзину"
    const handleCloseDelBtnClick = () => {
        setIsShowDeleteModal(false);
    };

    const handleAcceptClick = async () => {
        try {
            const cartItemsUpload = cartItems.map((item) => ({
                productId: item.id,
                price: item.price,
                type: 'Product',
                amount: item.quantity,
                comment: '',
            }));

            const response = await axios.post(
                'https://apihpwild.ru/orders/create',
                cartItemsUpload,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                }
            );

            if (response.data.success) {
                console.log('Заказ подтвержден');
                handleClearCart();
                setSuccessStatus(3);
                setIsShowSuccess(true);
                loadingHistory();
                loadingCurrentOrder();
                // setCurrentPage('PaidPage');
                setCurrentPage('MainPage');
            }
        } catch (error) {
            console.error('Ошибка подтверждения заказа ', error);
            setErrorStatus(4);
            setIsShowError(true);
        }
    };

    return (
        <div className='cart__wrapper'>
            {isShowDeleteModal && (
                <div className='cart__del_modal'>
                    <div className='cart__del_icon'>
                        <img
                            src={closeIcon}
                            alt='Закрыть'
                            onClick={handleCloseDelBtnClick}
                        />
                    </div>
                    <h1 className='cart__del_title'>Вы уверены?</h1>
                    <div className='cart__del_btns'>
                        <button
                            className='cart__del_btn'
                            onClick={handleClearCart}
                        >
                            Да
                        </button>

                        <button
                            className='cart__del_btn_active'
                            onClick={handleCloseDelBtnClick}
                        >
                            Нет
                        </button>
                    </div>
                </div>
            )}
            <div className='cart__page_items'>
                <div className='cart__page_logo'>
                    <img src={logoImage} alt='Logo' />
                </div>
                <h1 className='cart__page_title'>Ваш заказ</h1>

                <div className='cart__page_list'>
                    {cartItems.map((item) => (
                        <div className='cart__page_list_item' key={item.id}>
                            <div className='cart__page_list_name'>
                                {item.name}
                            </div>
                            <div className='cart__page_list_info'>
                                <p className='cart__page_list_price'>
                                    {item.price * item.quantity} ₽
                                </p>
                                <img
                                    src={delIcon}
                                    alt='Удалить'
                                    onClick={() =>
                                        handleDeleteItem(
                                            item.id,
                                            item.price,
                                            item.quantity
                                        )
                                    }
                                />
                            </div>
                        </div>
                    ))}
                </div>

                <div className='cart__page_btns'>
                    <button
                        className='cart__page_del'
                        onClick={handleDelBtnClick}
                    >
                        Очистить корзину
                    </button>
                </div>
            </div>
            <div className='cart__page_btns'>
                <button className='cart__page_btn' onClick={handleAcceptClick}>
                    Подтвердить
                </button>
                {/* <button className='cart__page_paid'>
                    Подтвердить и оплатить
                </button> */}
            </div>
        </div>
    );
};

export default CartPage;
